import fr from './messages_fr';
import en from './messages_en';
import nl from './messages_nl';
import de from './messages_de';

export default {
  fr, en, nl, de,
};



// WEBPACK FOOTER //
// ./src/messages.js